import React from 'react';
import PropTypes from 'prop-types';
import { StyledAlert, StyledButton } from './DelayedKnockWarning.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const DelayedKnockWarning = ({
  handleRetryKnock,
  clearDelayedKnockWarning
}) => {
  const title = 'Uh oh, something went wrong!';
  const content = 'Your request to join was not successful. Please try again.';

  const handleButtonClick = () => {
    handleRetryKnock();
    clearDelayedKnockWarning();
  };
  return (
    <StyledAlert type="warning" size="medium">
      <div className="header">
        <FontAwesomeIcon icon={faExclamationCircle} />
        <div className="title">{title}</div>
      </div>
      <div className="content">{content}</div>
      <div>
        <StyledButton onClick={handleButtonClick}>Send again</StyledButton>
      </div>
    </StyledAlert>
  );
};

DelayedKnockWarning.propTypes = {
  handleRetryKnock: PropTypes.func.isRequired,
  clearDelayedKnockWarning: PropTypes.func.isRequired
};

export default DelayedKnockWarning;
